import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "@store";

export const TRIGGER_ADS_LIST = "TRIGGER_ADS_LIST";

export interface RequestAdsListType {
  firstName: string;
  lastName: string;
  email: string;
  onboarded: string;
  profileProgress: 0;
  id: string;
  contactName: string;
}

export interface RequestAdsList {
  data: {
    content: RequestAdsListType[];
    totalCount: number;
  };
  state: boolean;
}

interface RequestAdsInterface {
  requestAdsListData: any;
  adsErrorData: object;
  isAdsLoading: boolean;
}

const initialState: RequestAdsInterface = {
  requestAdsListData: null,
  adsErrorData: {},
  isAdsLoading: false,
};

export const adsSlice = createSlice({
  name: "ads",
  initialState,
  reducers: {
    requestedAds: (state, action: PayloadAction<RequestAdsList>) => {
      state.requestAdsListData = action.payload;
      state.adsErrorData = {};
      state.isAdsLoading = false;
    },
    adsError: (state, action: PayloadAction<any>) => {
      state.requestAdsListData = null;
      state.adsErrorData = action.payload;
      state.isAdsLoading = false;
    },
    adsOngoing: (state) => {
      state.requestAdsListData = null;
      state.adsErrorData = {};
      state.isAdsLoading = true;
    },
  },
});

export const { requestedAds, adsError, adsOngoing } = adsSlice.actions;
export const getAllAds = (state: RootState) => state.ads;

export default adsSlice.reducer;
